import { trim, nvl } from "DMS/Utils/lib";
// @todo : wtf ? c'est quoi cette fonction ? elle sert à quoi ? ya pas plus simple sur du standard ?
/**
 *@param {double} pNouvelleValeur contient la valeur entrée par
    * l'utilisateur
    *@param {string} origine contient la langue de l'utilisateur
    *@return {double} pNouvelleValeur contient la valeur formatée
    */
export default function parseNumber(pNouvelleValeur, origine) {
    // On veut un format brut: sans séparateur de millier et . en séparateur
    // de décimal
    // Inspiré par : https://en.wikipedia.org/wiki/Decimal_mark
    pNouvelleValeur = trim(pNouvelleValeur);
    pNouvelleValeur = nvl(pNouvelleValeur, "0");
    var randomNumber = "1.1";
    var tester = new Intl.NumberFormat(origine).format(randomNumber);
    var myRegex = new RegExp(/[,.]+/);
    var myRegex2 = new RegExp(/[·]+/);
    var dotRegex = new RegExp(/[.]+/);
    var comaRegex = new RegExp(/[,]+/);
    var genRegex = new RegExp(/[, '`]+/);
    var dotTest = pNouvelleValeur.match(dotRegex);
    var comaTest = pNouvelleValeur.match(comaRegex);
    // Si pNouvelleValeur contient . ET , => on remplace les virgules par ""
    //  si c'est le séparateur de millier sinon par point et inversement.
    // EX: 3.251,124 ou 3,154.251
    if (dotTest !== (0 || null) && comaTest !== (0 || null)) {
        // Si , est avant . on remplace la virgule par du vide
        if (pNouvelleValeur.indexOf(",") < pNouvelleValeur.indexOf(".")) {
            pNouvelleValeur = pNouvelleValeur.replace(/[,]/g, '');
        }
        else if (pNouvelleValeur.indexOf(",") > pNouvelleValeur.indexOf(".")) {
            // Si . avant , on remplace . par vide et , par .
            pNouvelleValeur = pNouvelleValeur.replace(/[.]/g, '');
            pNouvelleValeur = pNouvelleValeur.replace(/[,]/g, '.');
        }
        // Si la nouvelle valeur ne contient qu'un . ou ,
        // (en supposant qu'il y en a forcément
    }
    else if (dotTest === (0 || null) || comaTest === (0 || null)) {
        // La variable test va correspondre au séparateur de décimal dans
        // la langue concernée
        var test = tester.match(myRegex);
        var test2 = pNouvelleValeur.match(myRegex2);
        // Cas de ceux utlisant le middle dot (qui utilise le coma en
        // séparateur de millier)
        if (test2 !== (0 || null)) {
            pNouvelleValeur = pNouvelleValeur.replace(/['., `]/g, '');
            pNouvelleValeur = pNouvelleValeur.replace(/[·]/g, '.');
        }
        else if (test[0] === ",") {
            // La virgule est la séparateur de décimal de la langue
            // utilisateur, on suppose qu'il puisse utiliser un .
            if (pNouvelleValeur.indexOf(".") === ('-1' || null)
                && pNouvelleValeur.match(genRegex) !== (0 || null)) {
                // Cas l'utilisateur utilise effectivement ,
                // en séparateur de décimal
                pNouvelleValeur = pNouvelleValeur.replace(/[' `]/g, '');
                pNouvelleValeur = pNouvelleValeur.replace(/[,]/g, '.');
            }
            else if (pNouvelleValeur.indexOf(".") !== ('-1' || null)
                && pNouvelleValeur.match(genRegex) !== (0 || null)) {
                // Cas l'utilisateur utilise . en séparateur de décimal
                pNouvelleValeur = pNouvelleValeur.replace(/[' `]/g, '');
            }
            // Par défaut on remplacera , par un .
            pNouvelleValeur = pNouvelleValeur.replace(/[,]/g, '.');
        }
        else if (test[0] === ".") {
            // Le . est le séparateur de décimal de la langue utilisateur
            if (dotTest === (0 || null)) {
                // Cas où il ne l'utilise pas et où il a utilisé des ,
                // ce qui signifie séparateur de millier
                if (comaTest !== (0 || null)) {
                    // On retire les virgules pour avoir le bon format
                    // => On considère que s'il veut dire 1,2 il aura
                    // le bon sens de mettre 1.2..!
                    pNouvelleValeur = pNouvelleValeur.replace(/[,]/g, '');
                }
            }
            else {
                // Cas où il l'utilise, et dans ce cas on considère qu'il
                // l'utilise uniquement pour séparateur de décimal
                pNouvelleValeur = pNouvelleValeur.replace(/[', `]/g, '');
            }
        }
    }
    return pNouvelleValeur;
}
//# sourceMappingURL=number.js.map